import React, { Fragment, useState, useRef, useEffect } from "react";
import { Calendar } from "react-date-range";
import { format } from "date-fns";
import Popover from "../popover";
import styles from "./style.module.css";

const DateInput = (props) => {
  const { value, onChange, placeholder, required, disabled, autoFocus, options, } = props;
  const dateFormat = options?.dateFormat || "dd MMM yyyy";
  const maxDate = options?.maxDate;
  const [date, setDate] = useState(value || new Date());
  const [inputValue, setInputValue] = useState(
    placeholder ? "" : format(date, dateFormat)
  );
  const [isOpen, setIsOpen] = useState(false);
  const inputRef = useRef(null);

  const handleOpenButton = () => {
    setIsOpen(true);
  };

  const handleCloseButton = () => {
    setIsOpen(false);
  };

  const handleDateChange = (item) => {
    setDate(item);
    setInputValue(format(item, dateFormat));
    setIsOpen(false);
    onChange(format(item, dateFormat));
  };

  useEffect(() => {
    if (value) {
      // Safely parse the date value
      const parsedDate = new Date(value.replace(/-/g, '/'));
      if (isNaN(parsedDate.getTime())) {
        // If invalid date, use current date as fallback
        setDate(new Date());
        setInputValue(format(new Date(), dateFormat));
      } else {
        setDate(parsedDate);
        setInputValue(format(parsedDate, dateFormat));
      }
    } else {
      setDate(new Date());
      setInputValue(format(new Date(), dateFormat));
      onChange(format(new Date(), dateFormat));
    }
    // eslint-disable-next-line 
  }, [dateFormat, value]);

  return (
    <Fragment>
      <div className={styles.date_input}>
        <input
          type="text"
          value={inputValue}
          onClick={handleOpenButton}
          ref={inputRef}
          placeholder={placeholder}
          required={required}
          readOnly
          disabled={disabled}
          autoFocus={autoFocus}
        />
        <Popover
          open={isOpen}
          buttonRef={inputRef}
          onClose={handleCloseButton}
          customClass={styles.date_popover}
          maxWidth="auto"
        >
          <Calendar
            direction="horizontal"
            className={styles.calendar}
            onChange={handleDateChange}
            date={date}
            showDateDisplay={false}
            color="#FF0800"
            maxDate={maxDate}
          />
        </Popover>
      </div>
    </Fragment>
  );
};

export default DateInput;
